import * as React from 'react';

import Text from 'components/core/Text';

import { Wrapper, Input, Label, Tip, Error, Icon } from './styles';

export default class extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      id: null,
    };
  }

  componentDidMount() {
    const { name } = this.props;

    this.setState({ id: `${name.replace(/\s/g, '')}-id` });
  }

  handleShowClick = () => {
    const { show } = this.state;
    this.setState({ show: !show });
  };

  render() {
    const {
      placeholder,
      className,
      label,
      type = 'text',
      tip = '',
      name,
      value,
      handleBlur,
      handleChange,
      errorMessage,
      alignLeft,
      meta = {},
      'aria-label': ariaLabel,
    } = this.props;
    const { touched = {}, errors = {} } = meta;
    const { id, show } = this.state;

    return (
      <Wrapper className={className}>
        <Input
          id={id}
          type={type === 'password' && show ? 'text' : type}
          placeholder={placeholder}
          name={name}
          value={value}
          onChange={handleChange}
          onBlur={handleBlur}
          error={errors[name] && touched[name]}
          errorMessage={errorMessage}
          alignLeft={alignLeft}
          aria-label={ariaLabel}
        />
        {label && (
          <Label htmlFor={id}>
            <Text variant="captionSmall" tag="span" color="grayLight">
              {type === 'password' ? <Icon onClick={this.handleShowClick} show={show} /> : null}{' '}
              {label}
            </Text>
          </Label>
        )}
        {errors[name] && touched[name] && !errorMessage && (
          <Error>
            <Text variant="caption" tag="h1" color="ruby">
              {typeof errors[name] === 'string' ? errors[name] : 'Invalid value'}
            </Text>
          </Error>
        )}
        {tip && (
          <Tip>
            <Text variant="caption" tag="span" color="gray">
              {tip}
            </Text>
          </Tip>
        )}
      </Wrapper>
    );
  }
}
